module.exports = __webpack_public_path__ + "static/img/partner-renai.d6d5080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner-renai.png
// module id = OKCb
// module chunks = 0